import { CommonButtonTypes } from 'Common/Types/Types';
import React, { Fragment } from 'react';
import { CommonButton, NextButton } from '../Buttons/Buttons';
import { useStyles } from './cards.style';

interface OverlapProps extends CommonButtonTypes {
	image?: any;
	information?: string;
	heading?: string;
	subheading?: string;
	next?: boolean;
	children?: any;
	upper?: boolean;
	rounded?: boolean;
	onClick?: any;
	options?: boolean;
	buttonColor?: any;
	buttonText?:any;
	// add this to toggle the achieved button 
	achieved? : any;
}

//next - prop activate the next button with an error
// the upper prop activates the upper text alone without the next button
const OverlapCard = ({
	image,
	common,
	information,
	heading,
	subheading,
	next,
	children,
	upper,
	rounded,
	onClick,
	options,
	buttonColor,
	buttonText,
	achieved
}: OverlapProps) => {
	const classes = useStyles({ common });
	return (
		<Fragment>
			<section className={classes.overlap}>
				<img src={image} alt="" className={classes.overlapImage} style={{ opacity: options ? 0 : 1 }} />
				{options && <img src={image} alt="" className={classes.overlapOptionImage} />}
				<div className={classes.overlapDiv}>
					{upper && (
						<div>
							<h5 className="text-center pt-5 mt-5">{heading}</h5>
							{subheading &&  <h6 className="text-center py-5 px-5">{subheading}</h6>}
							{/* <p className="px-5 pb-5">{information }</p> */}
							{ information && <p className="px-5 pb-5" style={{textAlign:'center'}}>{information }</p>}
						</div>
					)}
					<div>{children}</div>
				</div>
				{next && (
					<div className={classes.nextButton}>
						<NextButton
							onClick={onClick}
							common={{
								width: 'inherit',
								height: '48px',
								roundSvgBackground: 'white',
								arrowSvgColor: '#78393D',
								margin: '2rem 0',
							}}
						/>
					</div>
				)}

				{
					achieved  != true ? rounded && (
						<div className={classes.commonButton}>
							<CommonButton
								onClick={onClick}
								command={buttonText ? buttonText : "CHECK OUT EXERCISE"}
								common={{
									width: 'inherit',
									height: '48px',
									background: `${buttonColor ? buttonColor : 'white'}`,
									radius: '200px',
									margin: '2rem 0',
									color: '#78393D',
								}}
							/>
						</div>
					) : ''
				}
				{/* {rounded && (
					<div className={classes.commonButton}>
						<CommonButton
							onClick={onClick}
							command={buttonText ? buttonText : "CHECK OUT EXERCISE"}
							common={{
								width: 'inherit',
								height: '48px',
								background: `${buttonColor ? buttonColor : 'white'}`,
								radius: '200px',
								margin: '2rem 0',
								color: '#78393D',
							}}
						/>
					</div>
				)} */}
			</section>
		</Fragment>
	);
};

export default OverlapCard;
